<template>
  <div>
    <form @submit="sendEmail">
      <b-form-group label="To" label-class="text-truncate label-required">
        <b-form-input v-model="name" required placeholder="Full Name"/>
      </b-form-group>

      <b-form-group label="Email" label-class="text-truncate label-required">
        <b-form-input v-model="email" required type="email"/>
      </b-form-group>

      <b-form-group label="Subject" label-class="text-truncate label-required">
        <b-form-input v-model="subject" required placeholder="Subject"/>
      </b-form-group>

      <b-form-group label="Your Message" label-class="text-truncate">
        <b-form-textarea v-model="message"/>
      </b-form-group>

      <b-button variant="primary" type="submit">Send Email</b-button>
    </form>
  </div>
</template>

<script>
import GeneralMixins from "../../../mixins/GeneralMixins.js";

export default {
  props: ['projectId'],

  mixins: [GeneralMixins],

  data() {
    return {
      name: null,
      email: null,
      message: null,
      subject: null,
    }
  },

  methods: {
    sendEmail() {
      this.$http.post(`/customers/projects/email_share`, {
        name: this.name,
        email: this.email,
        subject: this.subject,
        message: this.message,
        project_id: this.projectId,
      }).then(fulfilled => {
        this.$emit("sentEmail")
        this.showToast("Your email was sent!")
      }, rejected => {
        this.showErrorToast(this.getErrorMessages(rejected.body, true));
      })
    }
  }
}
</script>